import { Controller } from '@hotwired/stimulus';
import WindowResizeObserver from '../utilities/window-resize-observer';

export default class extends Controller {
    initialize() {
        super.initialize();

        this.toggle = (event) => this._toggle(event);
        this.reposition = _ => this._calculatePositions();

        this.svgHeight = 25;
        this.svgWidth = 25;
        this.svgColor = '#6c7a91';

        this.openedNode = this._eyeOpened();
        this.closedNode = this._eyeClosed();
    }

    connect() {
        super.connect();

        const computedStyle = window.getComputedStyle(this.element);
        this.elementPaddingRight = parseFloat(computedStyle.getPropertyValue('padding-right'));

        if (this.element.hasAttribute('data-svg-height')) {
            this.svgHeight = this.element.getAttribute('data-svg-height');
        }

        if (this.element.hasAttribute('data-svg-width')) {
            this.svgWidth = this.element.getAttribute('data-svg-width');
        }

        if (this.element.hasAttribute('data-svg-color')) {
            this.svgColor = this.element.getAttribute('data-svg-color');
        }

        this._calculatePositions();

        this._insertNode(this.openedNode);
        this._insertNode(this.closedNode);

        WindowResizeObserver.observe(this.reposition);
        this.mutationObserver = new MutationObserver(this.reposition);
        this.mutationObserver.observe(document, { childList: true, subtree: true });
    }

    disconnect() {
        this.openedNode.removeEventListener('click', this.toggle);
        this.closedNode.removeEventListener('click', this.toggle);

        WindowResizeObserver.unobserve(this.reposition);
        this.mutationObserver.disconnect();

        super.disconnect();
    }

    _toggle(event) {
        if (event.currentTarget._controllerReference) {
            if (event.currentTarget._controllerReference.element.type === 'password') {
                event.currentTarget._controllerReference.element.type = 'text';
                event.currentTarget._controllerReference.openedNode.style.display = 'none';
                event.currentTarget._controllerReference.closedNode.style.display = 'inline';
            } else {
                event.currentTarget._controllerReference.element.type = 'password';
                event.currentTarget._controllerReference.openedNode.style.display = 'inline';
                event.currentTarget._controllerReference.closedNode.style.display = 'none';
            }
        }
    }

    toggle() {
        if (this.element.type === 'password') {
            this.element.type = 'text';
            this.openedNode.style.display = 'inline';
            this.closedNode.style.display = 'none';
        } else {
            this.element.type = 'password';
            this.openedNode.style.display = 'none';
            this.closedNode.style.display = 'inline';
        }
    }

    _insertNode(node) {
        if (this.element.nextSibling) {
            this.element.parentElement.insertBefore(node, this.element.nextSibling);
        } else {
            this.element.parentElement.appendChild(node);
        }
    }

    _calculatePositions() {
        const targetRect = this.element.getBoundingClientRect();

        this.openedNode.style.left = `${this.element.offsetLeft + (targetRect.width - this.svgWidth) - this.elementPaddingRight}px`;
        this.openedNode.style.top = `${this.element.offsetTop + (this.svgHeight / 2)}px`;

        this.closedNode.style.left = `${this.element.offsetLeft + (targetRect.width - this.svgWidth) - this.elementPaddingRight}px`;
        this.closedNode.style.top = `${this.element.offsetTop + (this.svgHeight / 2)}px`;

        this.element.style.paddingRight = `${this.elementPaddingRight + this.svgWidth + 5}px`;
    }

    _eyeOpened() {
        const node = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        node.setAttribute('fill', 'none');
        node.setAttribute('viewBox', '0 0 24 24');
        node.setAttribute('stroke-width', '1.5');
        node.setAttribute('stroke', 'currentColor');
        node.innerHTML = `
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"></path>
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
        `;

        node.style.position = 'absolute';
        node.style.cursor = 'pointer';
        node.style.userSelect = 'none';
        node.style.color = this.svgColor;
        node.style.width = `${this.svgWidth}px`;
        node.style.height = `${this.svgHeight}px`;

        node._controllerReference = this;
        node.addEventListener('click', this.toggle);

        return node;
    }

    _eyeClosed() {
        const node = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        node.setAttribute('fill', 'none');
        node.setAttribute('viewBox', '0 0 24 24');
        node.setAttribute('stroke-width', '1.5');
        node.setAttribute('stroke', 'currentColor');
        node.innerHTML = `
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"></path>
        `;

        node.style.display = 'none';
        node.style.position = 'absolute';
        node.style.cursor = 'pointer';
        node.style.userSelect = 'none';
        node.style.color = this.svgColor;
        node.style.width = `${this.svgWidth}px`;
        node.style.height = `${this.svgHeight}px`;

        node._controllerReference = this;
        node.addEventListener('click', this.toggle);

        return node;
    }
}
